import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { CreateUserRequest, UpdateUserRequest, User, UserCreateResponse, UserDetail } from "../models/user.model";

@Injectable({ providedIn: "root" })
export class UserApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.interactiveExperienceServiceUrl}/v1/admin/users`;

    getUsers(): Observable<{ users: User[] }> {
        return this.http.get<{ users: User[] }>(this.baseUrl);
    }

    createUser(body: CreateUserRequest): Observable<UserCreateResponse> {
        return this.http.post<UserCreateResponse>(this.baseUrl, body);
    }

    getUser(username: string): Observable<UserDetail> {
        return this.http.get<UserDetail>(`${this.baseUrl}/${username}`);
    }

    updateUser(username: string, body: UpdateUserRequest): Observable<User> {
        return this.http.put<User>(`${this.baseUrl}/${username}`, body);
    }

    deleteUser(username: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${username}`);
    }
}
